import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { EventCard } from '@opendoor/cinderblocks/platform/EventCard';

import { TextReminderCard } from 'sellDirect/components/ssva/TextReminderCard';
import { useQueryParams } from 'shared/helpers/hooks/useQueryParams';

/**
 * Event card that opens the modal for text reminders
 * showModal state keeps track of whether we should show the text reminder modal which is outside of the normal DOM structure
 */
export const TextReminderTrigger: React.FC = () => {
  const params = useQueryParams();
  const history = useHistory();
  // When "reminder" query param is set to "open", open modal automatically.
  const [showModal, setShowModal] = useState<boolean>(params.get('reminder') === 'open');
  return (
    <>
      <TextReminderCard
        isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false);
          // remove the "reminder" query param, so user don't see the modal again after reloading.
          params.delete('reminder');
          history.replace({ search: params.toString() });
        }}
      />
      <EventCard
        // Currently don't need to add "reminder" query param back.
        onClick={() => setShowModal(true)}
        analyticsName="text-reminder-schedule-card"
        chipOrIconProps={{
          name: 'date',
          color: 'neutrals0',
          size: 24,
        }}
        title="Need to do this later?"
        subtitle="Setup a reminder"
        textAsColumn
      />
    </>
  );
};
